import React, { useEffect } from 'react';
import SiteHeader from '../../shared/SiteHeader';
import SiteFooter from '../../shared/SiteFooter';
import { getAppInsights } from '../../appInsights';

const Services: React.FC = () => {
  useEffect(() => {
    document.title = 'Todonyx LLC - Services';

    const appInsights = getAppInsights();
    appInsights?.trackPageView({ name: 'Services' });
  }, []);

  return (
    <div className="page-wrapper">
      <SiteHeader />
      <div className="page-content container py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-8">
            <h1 className="display-5 fw-bold mb-4">Our Services</h1>
            <p className="lead text-muted mb-5">
              Expert full stack development consulting to bring your ideas to life
            </p>

            {/* C# Development */}
            <div className="card shadow-sm mb-4">
              <div className="card-body p-4">
                <div className="d-flex align-items-center mb-3">
                  <i className="bi bi-braces fs-1 text-success me-3"></i>
                  <h2 className="h3 mb-0">C# & .NET Development</h2>
                </div>
                <p className="mb-2">Robust backend solutions with C# and .NET. We specialize in:</p>
                <ul className="ms-3">
                  <li>.NET Core and .NET Framework applications across all versions</li>
                  <li>ASP.NET Core web applications and Web APIs</li>
                  <li>Microservices architecture and serverless computing</li>
                  <li>RESTful and GraphQL API design and implementation</li>
                  <li>Entity Framework Core, Dapper, and other ORM solutions</li>
                  <li>Desktop applications with WPF, WinForms, and MAUI</li>
                  <li>Real-time applications with SignalR</li>
                  <li>Background services and worker processes</li>
                  <li>Comprehensive testing (xUnit, NUnit, MSTest) and test-driven development</li>
                  <li>Migration and modernization of legacy .NET applications</li>
                </ul>
              </div>
            </div>

            {/* React Development */}
            <div className="card shadow-sm mb-4">
              <div className="card-body p-4">
                <div className="d-flex align-items-center mb-3">
                  <i className="bi bi-code-square fs-1 text-primary me-3"></i>
                  <h2 className="h3 mb-0">React Development</h2>
                </div>
                <p className="mb-2">
                  Build modern, responsive web applications with React. Our expertise includes:
                </p>
                <ul className="ms-3">
                  <li>Custom React applications with TypeScript or JavaScript</li>
                  <li>State management solutions (Redux, Context API, Zustand, Recoil)</li>
                  <li>
                    Component libraries and design systems (Material-UI, Ant Design, Chakra UI,
                    Bootstrap)
                  </li>
                  <li>Server-side rendering with Next.js for improved SEO and performance</li>
                  <li>Progressive Web Apps (PWAs) for offline-first experiences</li>
                  <li>
                    Comprehensive testing strategies (Jest, React Testing Library, Cypress,
                    Playwright)
                  </li>
                  <li>Performance optimization, code splitting, and lazy loading</li>
                  <li>Accessibility (a11y) compliance and best practices</li>
                </ul>
              </div>
            </div>

            {/* Azure Cloud Hosting */}
            <div className="card shadow-sm mb-4">
              <div className="card-body p-4">
                <div className="d-flex align-items-center mb-3">
                  <i className="bi bi-cloud fs-1 text-info me-3"></i>
                  <h2 className="h3 mb-0">Azure Cloud Hosting</h2>
                </div>
                <p className="mb-2">Scalable, secure cloud infrastructure on Microsoft Azure:</p>
                <ul className="ms-3">
                  <li>Azure App Service for web applications and APIs</li>
                  <li>Azure Static Web Apps for modern frontend hosting</li>
                  <li>Azure Functions and Logic Apps for serverless solutions</li>
                  <li>Azure Kubernetes Service (AKS) for container orchestration</li>
                  <li>Azure SQL Database, Cosmos DB, and other data storage solutions</li>
                  <li>Azure Blob Storage and CDN for static assets</li>
                  <li>Application Insights and Azure Monitor for observability</li>
                  <li>Azure DevOps and GitHub Actions for CI/CD pipelines</li>
                  <li>Virtual Networks, API Management, and security best practices</li>
                  <li>Cost optimization, scalability planning, and architecture review</li>
                </ul>
              </div>
            </div>

            {/* Call to Action */}
            <div className="alert alert-primary mt-5" role="alert">
              <h3 className="h5 mb-2">Ready To Get Started?</h3>
              <p className="mb-0">
                Contact us through our{' '}
                <a href="/about" className="alert-link">
                  About page
                </a>{' '}
                to discuss your project needs.
              </p>
            </div>
          </div>
        </div>
      </div>
      <SiteFooter />
    </div>
  );
};

export default Services;
